export const form_load_docs = {
    form: [
        {
            label: "documents_form_customer",
            type: "select",
            id: "customer",
            class: "_align _name",
            colm: 6,
            required: true
        },
        {
            label: "documents_form_category",
            type: "select",
            id: "category",
            class: "_align _name",
            colm: 6,
            required: true
        },
        {
            label: "documents_form_name",
            type: "input",
            id: "name",
            class: "_align _name",
            colm: 6,
            required: true
        },
    ]
}